import React, { JSX } from 'react';
import Style from './SmallButton.module.scss';

type Props = {
  href: string;
  text: string;
};

const SmallButton: React.FC<Props> = ({ href, text }): JSX.Element => {
  return (
    <a className={Style.button} href={href}>
      {text}
    </a>
  );
};

export default SmallButton;
